//あいうえお
<template>

  <div class="w-full">

    <p class="mb-5">{{contact.message}}</p>


    <div class="mb-10">
      <label class="block mb-1" for="inline-name">お名前：</label>
      <p>{{contact.name}}</p>
    </div>

    <div class="mb-10">
      <label class="block mb-1" for="inline-email">Eメールアドレス：</label>
      <p>{{contact.email}}</p>
    </div>

    <div class="mb-10">
      <label class="block mb-1" for="inline-age">年齢：</label>
      <p>{{contact.age}}</p>
    </div>

    <div class="mb-10">
      <label class="block mb-1" for="inline-gender">性別：</label>
      <p>{{contact.genders[contact.gender]}}</p>
    </div>

    <div class="mb-20">
      <label class="block mb-1" for="inline-content">ご感想、ご質問内容：</label>
      <p class="whitespace-pre">{{contact.content}}</p>
    </div>


    <div class="w-full flex flex-wrap justify-evenly items-center text-center ">
      <div class="w-full sm:w-1/2 mb-10 sm:mb-0"><button type="button" @click="prev" class="btn w-full sm:w-40">戻る</button></div>
      <div class="w-full sm:w-1/2 mb-0 sm:mb-0"><button type="button" @click="next" class="btn w-full sm:w-40">送信する</button></div>
    </div>


  </div>


</template>

<script>
export default {
  props: [
   'contact'
  ],

  methods: {
    prev(){
      this.$emit('step', 1);
    },
    next(){
      this.$emit('step', 3);
    },
  }
}
</script>

<style>

</style>
